import { useMutation, useQueryClient } from "@tanstack/react-query";
import { staffAPI } from "@/lib/staff-api";
import { queryKeys } from "@/lib/query-keys";
import type { CreateStaffResponse } from "@/lib/staff-api";

export const useCreateStaff = () => {
  const queryClient = useQueryClient();

  // Failure feedback lives in the form's error dialog (same as useUpdateStaff)
  // so every failure surfaces in one place instead of splitting across a toast.
  return useMutation<CreateStaffResponse, any, FormData>({
    mutationFn: (formData: FormData) => staffAPI.createStaff(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.staff.all });
    },
  });
};
